import { mutations as TYPES } from "./types";
// import { defaultState } from "./state";
import { FETCH } from "@/utils/list";

const mutations = {
  // [TYPES.DRAWER_RESET](state) {
  //   state = defaultState();
  // },
  [TYPES.INTEGRATION_FETCH_APPS](state, list) {
    let comparer = (obj, item) => {
      return obj.id === item.id;
    };
    FETCH(state.apps.list, list, comparer, null);
  },
};

export default mutations;
